import DocumentSection from "components/front/layout/DocumentSection";
import React, { FC } from "react";

export type Props = {};
const LegalSection: FC<Props> = () => {
  return (
    <DocumentSection>
      <section>
        <table className="show">
          <tbody>
          <tr>
            <th>事業者</th>
            <td>アニメファンド株式会社</td>
          </tr>
          <tr>
            <th>運営責任者</th>
            <td>加納 千稔</td>
          </tr>
          <tr>
            <th>所在地</th>
            <td>〒271-0091 千葉県松戸市本町17−11 芹澤ビル6F</td>
          </tr>
          <tr>
            <th>お問い合わせ</th>
            <td>
              <a href="https://animefund.zendesk.com/hc/ja/requests/new">お問い合わせ</a>
              <p>プロジェクトオーナーへのお問い合わせは、各プロジェクトページよりお問い合わせください。</p>
            </td>
          </tr>
          <tr>
            <th>メールアドレス</th>
            <td>
              <p>info@animefund.com</p>
            </td>
          </tr>
          <tr>
            <th>電話番号</th>
            <td>
              <p>050-3183-8912 ※電話でのお問い合わせは致しかねます。上記、お問い合わせ先へご連絡ください。</p>
            </td>
          </tr>
          <tr>
            <th>役務の対価</th>
            <td>
              <p>
                <strong>プロジェクトオーナーの支払う対価</strong>
              </p>
              <p>別途個別に定めるプロジェクト契約書に準じます。</p>
              <p className="content-block">
                <strong>応援者の支払う対価</strong>
              </p>
              <p>
                プロジェクトを応援する際のシステム利用料は完全無料となりました。
                <br />
                応援額の支払いはリターンの対価として、プロジェクトオーナーへ支払われます。
              </p>
              <p className="content-block">
                <strong>アニメショッピング購入者の支払う対価</strong>
              </p>
              <p>
                購入額の支払は対価として、プロジェクトオーナーへ支払われます。
              </p>
            </td>
          </tr>
          <tr>
            <th>応援者の支払方法</th>
            <td>
              <p>・クレジットカード決済：応援時点で即時決済。</p>
              <p>・コンビニ決済：応援後7日後以内にご選択頂きましたコンビニにてお支払いください。</p>
              <p>・銀行振込：応援後に記載されている銀行口座へお支払いください。</p>
            </td>
          </tr>
          <tr>
            <th>プロジェクトオーナーへの支払方法</th>
            <td>
              <p>
                支払いは、総応援金額から手数料相当額を差し引くことにより行われます。なお、銀行への振込手数料等その他の費用は弊社が負担します。
              </p>
            </td>
          </tr>
          <tr>
            <th>役務の内容およびその提供時期</th>
            <td>
              <p>
                当社は、プロジェクトオーナーが掲載するプロジェクトと、そのプロジェクトへ金銭的な応援をする会員とをマッチングする場を提供しています。
                <br />
                したがって、当社からプロジェクトオーナーへの役務の提供時期は、各プロジェクトの掲載開始から当該プロジェクトの掲載終了までとなります。
              </p>
              <p>
                なお、応援者に当社が直接提供する商品および役務はありません。リターンの提供はあくまで各プロジェクトオーナーから応援者に直接行われるものですので、各プロジェクトの記載に準じます。
              </p>
              <p>
                ※アニメショッピングにおいても、プロジェクトオーナーが役務を提供いたします。
              </p>
            </td>
          </tr>
          <tr>
            <th>返金・キャンセル</th>
            <td>
              <p>
                本サービスに掲載が開始されたプロジェクトは、原則、当社の承諾なく掲載を取り下げること、および、募集期間や目標金額、リターンの内容や金額を変更することはできません。
                <br />
                ただし、プロジェクトが募集期限終了前で、かつ目標金額に達成していない場合に、やむを得ない理由でプロジェクトの開始が実行できないとプロジェクトオーナーが判断した場合は、プロジェクトオーナーは速やかに当社までその旨を通知した上、当社が承諾した場合はプロジェクトの掲載を終了することができます。
              </p>
              <p>なお、各プロジェクトにおいて応援後の返金・キャンセルの受付は、一切お断りさせていただきます。</p>
              <p>ただし、プロジェクトがAll or Nothing方式で目標が達成されていない場合以下の方式で返金致します。</p>
              <p>・クレジットカード決済の場合：カード会社経由で返金</p>
              <p>・コンビニ決済の場合：銀行振込にて返金 ※口座情報の確認をさせて頂きます。</p>
            </td>
          </tr>
          </tbody>
        </table>
      </section>
    </DocumentSection>
  );
};
export default LegalSection;
